/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Platform, UserService } from '../services/user.service';
import { XaccBrowseComponent } from './xacc-browse.component';
import { XaccService } from './xacc.service';
import { Workflow } from '../services/workflow.service';

@Component({
  selector: 'xacc-reentry',
  template: '<div></div>',
  standalone: false,
})
export class XaccReentryComponent implements OnInit {
  connector: string;
  region: string;
  access: string;
  refresh: string;

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private xaccService: XaccService,
    private userService: UserService,
    private router: Router,
  ) {}

  // This is the entry page that middleware will redirect back to, so we need to grab all the important data from the query string
  ngOnInit() {
    // uncomment out the following for debug
    //debugger;
    this.connector = this.route.snapshot.paramMap.get('connector') || '';
    this.region = this.route.snapshot.paramMap.get('region') || '';
    this.access = this.route.snapshot.queryParams['access'] || 'canceled';
    this.refresh = this.route.snapshot.queryParams['refresh'] || '';

    if (this.userService.platform === Platform.MFD) {
      this.openBrowse();
    } else {
      // Post message to parent window and close
      const data = {
        connectorProvider: 'xacc',
        connector: this.connector,
        region: this.region,
        access: this.access,
        refresh: this.refresh,
      };
      if (window.opener) {
        window.opener.postMessage(data, window.location.origin);
        window.close();
      }
    }
  }

  openBrowse() {
    this.xaccService.region = this.region;
    this.xaccService.connector = this.connector;
    this.xaccService.connectorToken = this.access;
    this.xaccService.connectorRefreshToken = this.refresh;

    const cloudState = JSON.parse(sessionStorage.getItem('cloudState') || '{}');
    const cloudStateWf: unknown = cloudState.wf;
    if ((cloudStateWf as Workflow).id !== undefined) {
      const wf = cloudStateWf as Workflow;

      if (wf.output.cloudRepoOptions) {
        wf.output.cloudRepoOptions.access = this.access;
        wf.output.cloudRepoOptions.refresh = this.refresh;
        sessionStorage.setItem('cwf', JSON.stringify(wf));
        this.userService.setUser(JSON.stringify(cloudState.user));
        this.router.navigate(['workflows-mfd'], {
          relativeTo: this.route.parent,
        });
      } else {
        const modalRef = this.modalService.open(XaccBrowseComponent, {
          windowClass: 'xrx-popup modal-max',
        });
        modalRef.result
          .then((repoOptions) => {
            wf.output.cloudRepoOptions = repoOptions;
            sessionStorage.setItem('cwf', JSON.stringify(wf));
            this.userService.setUser(JSON.stringify(cloudState.user));
            this.router.navigate(['workflows-mfd'], {
              relativeTo: this.route.parent,
            });
          })
          .catch(() => {
            sessionStorage.setItem('cwf', JSON.stringify(wf));
            this.userService.setUser(JSON.stringify(cloudState.user));
            sessionStorage.removeItem('cloudState');
            this.router.navigate(['workflows-mfd'], {
              relativeTo: this.route.parent,
            });
          });
      }
    }
  }
}
